import React, { useState, useEffect } from "react";
import { Card, CardBody, Col, Row, Input, Label, select,AccordionItem,AccordionBody,AccordionHeader,UncontrolledAccordion, FormGroup} from "reactstrap";
import moment from "moment";
import "../Account/jobspace-account.css"; // new JobSpace design system (reskin only)
//import { Button, Accordion, } from "react-bootstrap";

//Import Images
import { AppConfiguration } from "read-appsettings-json";
import { GetRequest, PostRequest } from '../../noser-dataaccess'
import axios from 'axios'
import BootstrapTable from 'react-bootstrap-table-next';
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";

const HiredCandidList = () => {

    const [listOfJobs, setDlistOfJobs] = useState([]);
    const [mainGrid, setmainGrid] = useState([
        {
            "id":"1",
            "postingId":"1",
            "name":"tasyo",
            "title":"tambay",
            "expectedSalary":"100,000",
            "city":"makati",
            "resume":"",
            "ScheduleInterview":"",
            "action2":"",
        },
        {
            "id":"phr-1-2-3",
            "postingId":"phr-1-2-3",
            "name":"dio",
            "title":"food tester",
            "expectedSalary":"40,000",
            "city":"taguig",
            "resume":"",
            "ScheduleInterview":"",
        }
    ]);
    const [companyProfiles, setcompanyProfiles] = useState([]);
    const [jobPosted, setjobPosted] = useState([]);
    const [search, setsearch] = useState("");
    const [statusData, setstatusData] = useState([
       
        {
           "id":"1",
           "label":"New",
           "value":"NW"
        },
        {
            "id":"2",
            "label":"pre-screen",
            "value":"PS"
        },
        {
            "id":"3",
            "label":"keep warm",
            "value":"KW"
        },
        {
            "id":"4",
            "label":"shorlisted",
            "value":"SL"
        },
        {
            "id":"5",
            "label":"not qualified",
            "value":"NQ"
        },
    ]);
    const [jobRef, setjobRef] = useState("");
    const [pstingDateFilter, setpstingDateFilter] = useState("");
    const [jobPostStatus, setjobPostStatus] = useState("");
    const [jobtitlefilter, setjobtitlefilter] = useState("");
    const [endDateFilter, setendDateFilter] = useState("");



    const rowClasses = 'custom-row-class-success';


    useEffect(() => {
        GetCandidates()
        //GetJobPosted()
    },[]);

    

    const GetCandidates = async() => {

        let filter_data = {"isDeleted": "0",}
        let dataTmp = []

        const Params = {
          "_collection" : "Candidates",
          "filter_data" : filter_data
        }
        axios
        .post(AppConfiguration.Setting().jobspaceapi + "action/get", Params)
        .then(res => {

            let data = res.data
            console.log("data")
            console.log(data)
            let newstr2=""
            data.Candidates.map(function(itm,i){
                //console.log("itm")
                //console.log(itm)
                const strJson = itm.replace("","").replace("ObjectId(","").replace(")","").replace("_","")
                const json = JSON.parse(strJson.replace(/'/g,'"'));
                json.hireDate = json.hireDate===""? "" : moment(json.hireDate).format('MM/DD/YYYY')
                dataTmp.push(json)
            })    
            console.log("dataTmp GetCandidates" )
            console.log(dataTmp)

            setDlistOfJobs(dataTmp)   
            setmainGrid(dataTmp) 
        })
        .catch(error =>{
            alert("error: " + error)
        })
    }

    const helperBuildCriteria=()=>{

        let _filterData = ""
       
        let _jobRefNo = ""
        let _jobtitle = ""
        let _postingDate = ""
        let _EndDate = ""
        let _status = "" 

        //let transactionDate = (this.state.transactionDate) ? moment(this.state.transactionDate).format('MM/DD/YYYY') : ""
        
        if (jobRef != "" || jobRef !== "") {
            _jobRefNo = "postingId" + ":" + jobRef + ","
        }
        if (pstingDateFilter != "" || pstingDateFilter !== "") {
            _postingDate = "dateHired" + ":" + moment(new Date(pstingDateFilter)).format('MM/DD/YYYY') + ","
        }
        if (endDateFilter != "" || endDateFilter !== "") {
            _EndDate = "endDate" + ":" + endDateFilter + ","
        }
        if (jobtitlefilter != "" || jobtitlefilter !== "") {
            _jobtitle = "title" + ":" + jobtitlefilter + ","
        }
        
     /*    if (this.state.docNo != "" || this.state.docNo !== "") {
            _docNo = "docNo" + ":" + this.state.docNo + ","
        }
        if ( this.state.selectedClientName != "" || this.state.selectedClientName !== "" ) {
             _client = "clientName" + ":" + this.state.selectedClientName + ","
        }
        if ( this.state.selectedstatus!= "" || this.state.selectedstatus!== "" ) {
            _status= "status" + ":" + this.state.selectedstatus+ ","
        }
        if ( this.state.filterTranscDate!= "" || this.state.filterTranscDate!== "" ) {
            _transacDate = "transacDate" + ":" + this.state.filterTranscDate+ ","
        } */
      
        _filterData = "isDeleted" + ":" + "0," +_jobRefNo + _status + _jobtitle + _postingDate + _EndDate
        //console.log("_transacDate _transacDate _transacDate _transacDate")
        //console.log(_transacDate)
        return _filterData
    }

    const handleChangeSearch = () => {
        /* if(this.state.payrollDate === ""){
            this.setState(  {
                isloading       :   false,
                alerttype       :   "Warning!",
                isshow          :   true,
                color           :   "warning",
                message         :   "Please select payroll date!",
                fade            :   true
            })
            return
        } */

        let _fdata = helperBuildCriteria()
        let _filterData = _fdata.split(",")
        let _objfd = {}

        let jsonData = {};
        for (let i = 0; i < _filterData.length - 1; i++) { 
            let columnName = _filterData[i].split(":")[0]
            _objfd[columnName] = _filterData[i].split(":")[1];
        }
        console.log("filter_data")
        console.log(_objfd)

        GetFilterResult(_objfd);
    }

    const GetFilterResult = async(_objfd) => {

        let filter_data = {}
        let dataTmp = []

        const Params = {
          "_collection" : "Candidates",
          "filter_data" : _objfd
        }
        console.log("Params GetFilterResult")
        console.log(Params)
        axios
        .post(AppConfiguration.Setting().jobspaceapi + "action/get", Params)
        .then(res => {

            let data = res.data
            console.log("data")
            console.log(data)
            let newstr2=""
            data.Candidates.map(function(itm,i){
                //console.log("itm")
                //console.log(itm)
                const strJson = itm.replace("","").replace("ObjectId(","").replace(")","").replace("_","")
                const json = JSON.parse(strJson.replace(/'/g,'"'));
                dataTmp.push(json)
            })    
            //console.log("dataTmp GetCandidates" )
            //console.log(dataTmp)

            setDlistOfJobs(dataTmp)   
            setmainGrid(dataTmp) 
        })
        .catch(error =>{
            alert("error: " + error)
        })
    }

    const rowEvents = {
      /*   onClick: (e, row, rowIndex) => {
            //console.log("onClick")
            //console.log(rowIndex)
            //handleView(row)
           
        }, */
    }

    const GridDataModified=(oldValue, newValue, id, column , index)=>{
        mainGrid.map(function(item,i,index) {
            if (item.id === id){
                item.isModified = newValue!=oldValue ? "1" : "0"
               /*  console.log("GridDataModified item")
                console.log(item.isModified)
                console.log(item.headerId) */
                if(item.isModified == "1"){
                    saveGrid(item)
                 
                }
               
                
                
            }
        })
    }

    const saveGrid=(item)=>{

        const updateParams = {
    
            "_collection" : "Candidates",
            "doc_data"    : item,
            "_id"         : item.headerId,
      
        }

    
        console.log("saveGrid updateParams")
        console.log(updateParams)
      
        axios
        .post(AppConfiguration.Setting().jobspaceapi + "action/update_one", updateParams)
        .then(res => {
            let data = res.data
            
            console.log("update_one data")
            console.log(data)
            console.log("update_one data end")
          
        
        }).catch(error =>{
            
            console.log("error: " + error)
          
    
        })
    }

    const onChangejobRef = (e) => {
        setjobRef(e.target.value)
    }
    const onChangepstingDateFilter = (e) => {
        setpstingDateFilter(e.target.value)
    }
    const onChangejobPostStatus = (e) => {
        setjobPostStatus(e.target.value)
    }
    const onChangejobtitlefilter = (e) => {
        setjobtitlefilter(e.target.value)
    }
    const onChangeendDateFilter = (e) => {
        setendDateFilter(e.target.value)
    }

    const columns = [
        {

            dataField   : 'postingId',
            text        : 'Job Post Reference',
            editable:false,
            headerStyle : () => {
            
                return { width  : "20%", color:"green", fontWeight : "bold" };
            },
            style:{ whiteSpace: 'nowrap',fontSize:'14px', color: "#000000" }

        },
        {

            dataField   : 'title',
            text        : 'Job Title',
            editable:false,
            headerStyle : () => {
                return { width  : "20%", color:"green", fontWeight : "bold" };
            },
            style:{ whiteSpace: 'nowrap',fontSize:'14px', color: "#000000" }
            

        },
        {

            dataField   : 'name',
            text        : 'Name of Candidate',
            editable:false,
            headerStyle : () => {
                return { width  : "10%", color:"green", fontWeight : "bold" };
            },
            style:{ whiteSpace: 'nowrap',fontSize:'14px', color: "#000000" }
            

        },
        {

            dataField   : 'dateHired',
            text        : 'Hired Date',
            editable:false,
            headerStyle : () => {
                return { width  : "10%", color:"green", fontWeight : "bold" };
            },
            style:{ whiteSpace: 'nowrap',fontSize:'14px', color: "#000000" }
            

        },
        {

            dataField   : 'remarks',
            text        : 'Remarks',
            editable:false,
            headerStyle : () => {
                return { width  : "10%", color:"green", fontWeight : "bold" };
            },
            style:{ whiteSpace: 'nowrap',fontSize:'14px', color: "#000000" }
            

        },
        
       
    ]

    const selectRow = {
        //mode: 'checkbox',
        clickToSelectAndEditCell: false,
        hideSelectColumn: true,
        onSelect: (row, isSelect, rowIndex, e) => {
            let disable = true
            listOfJobs.map(function(item,i){
                if(item.id===row.id)
                {
                    ////console.log(row)
                    item.isDeleted = isSelect ? "1" : "0"
                    item.isModified = isSelect ? "1" : "0"
                    disable = isSelect ? false : true
                }
            })
        }
    };

    return (
        <React.Fragment>
            <Card className="job-detail overflow-hidden mt-1 jsa-root" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", background: "#f4f7f4", minHeight: "100vh", color: "#16271f", border: "none", boxShadow: "none" }}>
                <CardBody className="p-4" style={{ marginTop : "3%"}}>
                    <Row>
                        <Col lg={1}></Col>
                        <Col lg={10}>
                            <Label className="mt-3" style={{color:"#16271f", fontSize: "26px", fontWeight: 800, letterSpacing: "-.02em", marginTop:"25px"}}>Hired Candidates</Label><br />
                            <Card className="mt-1" style={{ border: "1.5px solid #e8ede9", borderRadius: 18, boxShadow: "0 8px 26px rgba(20,50,38,.05)" }}>
                                <Row className="mt-2">
                                    <Col lg={1}>
                                    </Col>
                                    <Col lg={2}>
                                        <Label  style={{ marginTop:"10px", marginLeft:'29px', color:"#0A6219", fontSize: "14px", fontWeight: "bold"}}>Job Post Reference : </Label>
                                    </Col>
                                    <Col lg={2}>
                                        <Input
                                            type="text"
                                            className="form-control"
                                            id="nameControlInput"
                                            //placeholder="Max Salary Offer"
                                            style={{ borderStyle: "outset",marginLeft:"-55px"/* marginBottom:"5px",background:"#F0FEED" */}}
                                            value={jobRef}
                                            onChange={onChangejobRef}
                                                
                                        />
                                    </Col>
                                    <Col lg={2}>
                                        <Label  style={{ marginTop:"10px", marginLeft:'29px',color:"#0A6219" , fontSize: "14px", fontWeight: "bold"}}>Posted Date : </Label>
                                    </Col>
                                    <Col lg={2}>
                                        <Input
                                            type="date"
                                            className="form-control"
                                            id="nameControlInput"
                                            //placeholder="Max Salary Offer"
                                            style={{ borderStyle: "outset",marginLeft:"-85px"/* marginBottom:"5px",background:"#F0FEED" */}}
                                            value={pstingDateFilter}
                                            onChange={onChangepstingDateFilter}
                                                
                                        />
                                    </Col>
                                    {/* <Col lg={2}>
                                        <Label  style={{ marginTop:"10px", marginLeft:'29px',color:"#0A6219" , fontSize: "14px"}}>Job Post Status : </Label>
                                    </Col>
                                    <Col lg={2}>
                                        <Input
                                            type="text"
                                            className="form-control"
                                            id="nameControlInput"
                                            //placeholder="Max Salary Offer"
                                            style={{ borderStyle: "outset",marginLeft:"-85px"}}
                                            value={jobPostStatus}
                                            onChange={onChangejobPostStatus}
                                                
                                        />
                                    </Col> */}
                                    
                                </Row>
                                <Row className="mt-3"  style={{  marginBottom:"20px",}}>
                                    <Col lg={1}>
                                    </Col>
                                    <Col lg={2}>
                                        <Label  style={{ marginTop:"10px", marginLeft:'29px', color:"#0A6219" , fontSize: "14px", fontWeight: "bold"}}>Job Title : </Label>
                                    </Col>
                                    <Col lg={2}>
                                        <Input
                                            type="text"
                                            className="form-control"
                                            id="nameControlInput"
                                            //placeholder="Max Salary Offer"
                                            style={{ borderStyle: "outset",marginLeft:"-55px"/* marginBottom:"5px",background:"#F0FEED" */}}
                                            value={jobtitlefilter}
                                            onChange={onChangejobtitlefilter}
                                                
                                        />
                                    </Col>
                                    <Col lg={2}>
                                        
                                    </Col>
                                    <Col lg={2}>
                                    </Col>
                                    {/* <Col lg={2}>
                                        <button type="submit" className="btn-success noser-button-md" onClick={handleChangeSearch} style={{minWidth : "10%", textAlign: "center", marginRight : "2%", backgroundColor: "transparent", border: "2px solid green", fontWeight: "bold", color : "white"}}>
                                            Search
                                        </button>
                                        <button type="submit" className="noser-button-md" onClick={() => window.location.reload(true)} style={{ padding: "9px 22px", textAlign: "center", background: "#fff", border: "1.5px solid #dde5df", borderRadius: 100, fontWeight: 700, color: "#2c3d44" }}>
                                            Clear
                                        </button>
                                    </Col> */}
                                    <Col lg={2}>
                                        <button type="submit" className="btn-success noser-button-md" onClick={handleChangeSearch} style={{ padding: "9px 22px", textAlign: "center", marginRight: "8px", background: "#009b57", border: "none", borderRadius: 100, fontWeight: 700, color: "#fff", boxShadow: "0 4px 12px rgba(0,154,87,.28)" }}>
                                            Search
                                        </button>
                                        <button type="submit" className="noser-button-md" onClick={() => window.location.reload(true)} style={{ padding: "9px 22px", textAlign: "center", background: "#fff", border: "1.5px solid #dde5df", borderRadius: 100, fontWeight: 700, color: "#2c3d44" }}>
                                            Clear
                                        </button>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                        <Col lg={1}></Col>
                    </Row>
                    <Row>
                        <Col lg={1}></Col>
                        <Col lg={10}>
                            <Card className="mt-2" style={{ border: "1.5px solid #e8ede9", borderRadius: 18, boxShadow: "0 8px 26px rgba(20,50,38,.05)" }}>
                                <CardBody>
                                    <BootstrapTable
                                        keyField="headerId"
                                        data={ mainGrid.filter(x=>x.status === "Hired" ).sort((a, b) => a.id < b.id ? 1 : -1)  }
                                        columns={ columns }
                                        bordered={ false }
                                        rowEvents={ rowEvents }
                                        noDataIndication={ () => <div>No record found.</div> }
                                        cellEdit = { cellEditFactory({
                                            mode: 'dbclick',
                                            blurToSave: true,
                                            afterSaveCell: (oldValue, newValue, row, column) => {
                                                GridDataModified(oldValue, newValue, row.id, column.dataField , row)
                                                }
                                            })
                                        }
                                        selectRow = { selectRow }
                                        //striped
                                        hover
                                        condensed
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                        <Col lg={1}></Col>
                    </Row>
                </CardBody>
            </Card>
        </React.Fragment>
    );
};

export default HiredCandidList;
